var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('menu-wrapper'),_c('router-view'),_c('footer-wrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }